import React from 'react';
import { Container } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="py-3 mt-4 bg-light">
      <Container className="text-center text-muted">
        <p className="mb-0">2centavos © {new Date().getFullYear()}</p>
      </Container>
    </footer>
  );
};

export default Footer; 